import { type IdentityVerification, VerificationMethod } from '@urbanx/agx.campaigns.client';
import {
  AgxBadge,
  AgxSpacer,
  type BadgeColor,
  isIdentityVerificationStep1Valid,
} from '@urbanx/agx.ui-components2';

interface IdentityVerificationIndicatorProps {
  id: string;
  identityVerification?: IdentityVerification;
}

const IdentityVerificationIndicator = ({
  id,
  identityVerification,
}: IdentityVerificationIndicatorProps) => {
  let colour: BadgeColor = 'red';
  let text = 'Not verified';

  if (isIdentityVerificationStep1Valid(identityVerification)) {
    if (identityVerification?.verificationMethod === VerificationMethod.InPerson) {
      colour = 'green';
      text = 'Verified';
    } else if (identityVerification?.verificationMethod === VerificationMethod.Biometric) {
      colour = 'lightgrey';
      text = 'Biometric required';
    } else {
      colour = 'lightgrey';
      text = 'No photo ID';
    }
  }

  return (
    <AgxSpacer id={id} direction="horizontal" flexShrink={0} style={{ width: 'fit-content' }}>
      <AgxBadge type="colourfill" colour={colour} size="sm" text={text} />
    </AgxSpacer>
  );
};

export default IdentityVerificationIndicator;
